// Load jQuery
import $ from 'jquery';
window.$ = window.jQuery = $;

// load fonts
WebFont.load({
    typekit: {
        id: 'rng3mwq'
    },
    active: function() { // helps stop flash of unstyled text
        sessionStorage.fontsLoaded = true 
    }
});

// Load BS
require('bootstrap');

//Load Libraries
require('flatpickr/dist/flatpickr.min');
require('magnific-popup/dist/jquery.magnific-popup.min');
require('objectFitPolyfill/dist/objectFitPolyfill.min');
require('select2/dist/js/select2.full.min');
require('slick-slider/slick/slick.min');

//Load Modules
require('./modules/accordion');
require('./modules/animatein');
require('./modules/bannerVideo');
require('./modules/formInputs');
require('./modules/localVideoBlock');
require('./modules/menu');
require('./modules/modal');
require('./modules/scrollTo');
require('./modules/searchToggle');
require('./modules/shareSocial');
require('./modules/sideMenu');
require('./modules/tabs');
require('./modules/alert');
require('./modules/sliders');

// load plugins
require('./plugins/isotope.pkgd');
require('jquery-zoom/jquery.zoom');

(function ($) {
    $.fn.changeElementType = function (newType) {
        var attrs = {};

        $.each(this[0].attributes, function (idx, attr) {
            attrs[attr.nodeName] = attr.nodeValue;
        });

        this.replaceWith(function () {
            return $("<" + newType + "/>", attrs).append($(this).contents());
        });
    }
})(jQuery);

$(document).ready(function() {

    if ($('.openSelectOnClick').length) {
        $('.openSelectOnClick').each(function () {
            var thisSelectFor = $(this).attr('for');
            var thisSelect = $(this).parents('.field_wrap').find('select')
            console.log(thisSelect);
            $("label[for='"+thisSelectFor+"']").on("click", function () {
                if (thisSelect.attr('data-opened') == 'true') {
                    thisSelect.select2('close');
                    thisSelect.attr('data-opened', false);
                } else {
                    thisSelect.select2('open');
                    thisSelect.attr('data-opened', true);
                }
            });
        });
    }
    // Booking menu
    if($(window).width() < 992) { // on tablet/mobile
        $('.__header').click(function() {
            $('.navwrap').removeClass('__active');
            $(this).toggleClass('__active');
            $('.burger').removeClass('__active');
            $('.navwindow').hide();
            $('.booking-menu').toggleClass('__active');
            $('body').toggleClass('__active');

            if ($('.__header').hasClass('__active')) {
                $('.burger').addClass('__white-bg');
                $('body').removeClass('__mobile');
            } else {
                $('.burger').removeClass('__white-bg');
            }
        })
    } else { // on desktop
        $('.__header').click(function() {
            $('.__header').toggleClass('__active');
            $('.booking-menu').slideToggle(400);
        })
    }

    $('.header-basket').mouseover(function() {
        $('.header-basket-dropdown').fadeIn(400);
        $('.booking-menu').slideUp(400);
        $('.__header').removeClass('__active');
    })

    $('.header-basket').mouseleave(function() {
        $('.header-basket-dropdown').fadeOut(400)
    })

    $('.menu-item-has-children > a > .icon').click(function(e) {
        if ($(e.target).is($(this))) {
            e.preventDefault();
            $(e.target).parent().toggleClass('__active');  
            $(this).parent().next('ul').slideToggle(400);
        }
    })

    // @BE: this controls the radio buttons on checkout - could it be moved so that it only fires on the checkout page specifically?
    $('form.checkout').on('change', function() {
        // remove checkmark from all radio buttons
        $('input[type="radio"]').closest('span.radio-button').removeClass('__active');
        // add checkmark to active radio button
        $('input[type="radio"]:checked').closest('span.radio-button').addClass('__active');
        
        // remove background from non-selected options
        $('input[type="radio"]').closest('li.wc_payment_method').removeClass('__selected')
        // add background to selected option
        $('input[type="radio"]:checked').closest('li.wc_payment_method').addClass('__selected')
    });

    // @BE: this controls the checkbox on the "my account login" and "checkout" page - could it be moved so that it only fires on those pages?
    $('.woocommerce-checkbox input').click(function() {
        $(this).parent().toggleClass('__selected');
    })

    // @BE: could the following code be included on all woocomm pages? - adds image polyfill to imgs on IE
    if (window.document.documentMode) { //checks for IE
        $(window).on("load", function () {
            objectFitPolyfill();
        });
    }
    
    // Select with no search
    $('.__select.__nosearch select').each(function () {
        var selectId = $(this).parent();
        $(this).select2({
            containerCssClass: 'select2-css',
            minimumResultsForSearch: Infinity,
            dropdownParent: selectId
        })
    });

    $(function () {
        $(".videoblock").each(function () {
            var altVideoSrc = $(this).data('mfp-src');
            if (altVideoSrc.includes('https://youtu.be')) {
                var newStr = altVideoSrc.split('https://youtu.be/')[1];
                var newYoutubeUrl = 'https://www.youtube.com/watch?v=' + newStr;
                $(this).attr('data-mfp-src', newYoutubeUrl);
            }
            $(this).magnificPopup({
                type: "iframe",
                removalDelay: 160,
                preloader: !1,
                fixedContentPos: !1
            })
        });
    });

    $('.imagemodal').magnificPopup({
        type: 'image',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false,
        gallery: {
            enabled: true,
            navigateByImgClick: true,
            preload: [0, 1] // Will preload 0 - before current, and 1 after the current image
        }
    });

    $(function () {
        $(document).ready(function () {
            $(".slider-items").each(function () {
                var thisElement = $(this);
                thisElement.slick({
                    infinite: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    prevArrow: thisElement.closest('.slider').find('.sliderPrevButton'),
                    nextArrow: thisElement.closest('.slider').find('.sliderNextButton'),
                    mobileFirst: true,
                    responsive: [{
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 1,
                            centerMode: true,
                            variableWidth: true,
                        }
                    }, ]
                });
            })
            var progressBar = $('.progress');
            var progressBarLabel = $('.slider__label');
            $(".slider-items").on("beforeChange", function (event, slick, currentSlide, nextSlide) {
                var calc = ((nextSlide) / (slick.slideCount - 1)) * 100;

                progressBar
                    .css('background-size', calc + '% 100%')
                    .attr('aria-valuenow', calc);

                progressBarLabel.text(calc + '% completed');
            })

            $('.package-slider').each(function () {
                var thisElement = $(this);
                thisElement.slick({
                    infinite: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    prevArrow: false,
                    nextArrow: false,
                    mobileFirst: true,
                    dots: true,
                    variableWidth: true,
                    responsive: [{
                            breakpoint: 600,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 1,
                                variableWidth: false,
                            }
                        },
                        {
                            breakpoint: 992,
                            settings: "unslick"
                        }
                    ]
                });
            })
        });

        
    });

    $('.gallery-list-grid-item').magnificPopup({
        type: 'image',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false,
        image: {
            titleSrc: 'Title',
        },
        gallery: {
            enabled: true,
            navigateByImgClick: true,
            preload: [0, 1] // Will preload 0 - before current, and 1 after the current image
        }
    });

    $('.tagblock-reset-btn').click(function () {
        $('.gallery-list-grid').isotope({
            filter: '*',
        })
        $('.gallery-list-grid-item').magnificPopup({
            type: 'image',
            removalDelay: 160,
            preloader: false,
            fixedContentPos: false,
            gallery: {
                enabled: true,
                navigateByImgClick: true,
                preload: [0,
                    1
                ] // Will preload 0 - before current, and 1 after the current image
            }
        });
    })

    $('.tagblock-btn').each(function () {
        let thisBtn = $(this)
        thisBtn.click(function () {
            $('.gallery-list-grid').isotope({
                filter: `.${thisBtn.text().toLowerCase()}`
            })
            $(`.gallery-list-grid-item.${thisBtn.text().toLowerCase()}`).magnificPopup({
                type: 'image',
                removalDelay: 160,
                preloader: false,
                fixedContentPos: false,
                gallery: {
                    enabled: true,
                    navigateByImgClick: true,
                    preload: [0,
                        1
                    ] // Will preload 0 - before current, and 1 after the current image
                }
            })
        })
    })



    // Isotope

    var galleryOptions = {
        packery: {
            columnWidth: '.gallery-list-grid-item'
        },
        itemSelector: '.gallery-list-grid-item',
        percentPosition: true
    }

    var gallery = $('.gallery-list-grid').isotope(galleryOptions);

    var filters = $('.isotopeFilters .tagblock-btn');

    filters.on("click", function () {
        var category = $(this).data('category').toLowerCase();;
        console.log(category)
        $('.gallery-list-grid-item').each(function () {
            if (($(this).hasClass(category))) {
                console.log(this)
                // $(this).changeElementType("a");
            } else {
                // $(this).changeElementType("span");
            }
        });
        gallery.isotope('layout');
    });

    $('.slider-complex-slider').each(function () {
        var thisElement = $(this);
        thisElement.slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            prevArrow: $(this).parent().find('.sliderPrevButton'),
            nextArrow: $(this).parent().find('.sliderNextButton'),
            mobileFirst: true,
            dots: false,
            variableWidth: true,
            asNavFor: '.slider-complex-nav',
        });
    })

    $('.slider-complex-nav').slick({
        asNavFor: '.slider-complex-slider',
        dots: true,
        arrows: false,
    })

    $('.slider-complex-slider').on('beforeChange', function () {
        $('.fadeOnSlide').fadeTo('fast', 0);
    });

    $('.slider-complex-slider').on('afterChange', function () {
        $('.fadeOnSlide').fadeTo('fast', 1);
        
        // set the slider title
        $('.slider-complex-info-title').text($('.slider-complex-slider')
            .find('.slick-active img')
            .data('title'));

        // set the slide description
        $('.slider-complex-info-text').text($('.slider-complex-slider')
            .find('.slick-active img')
            .data('description'));

        // set the previous slide title
        $('.prevButtonText').text($('.slider-complex-slider')
            .find('.slick-active')
            .prev()
            .find('img')
            .data('title'));

        // set the next slide title
        $('.nextButtonText').text($('.slider-complex-slider')
            .find('.slick-active')
            .next()
            .find('img')
            .data('title'));
    });

    $(".upcomingevents-slider").each(function () {
        var thisElement = $(this);
        thisElement.slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            prevArrow: thisElement.closest('.upcomingevents').find('.sliderPrevButton'),
            nextArrow: thisElement.closest('.upcomingevents').find('.sliderNextButton'),
            mobileFirst: true,
            variableWidth: true,
            responsive: [{
                    breakpoint: 450,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 3,
                    }
                },
            ]
        });
    })
    var progressBar = $('.progress');
    var progressBarLabel = $('.slider__label');
    var sliderButton = $('.slider-button');
    $(".upcomingevents-slider").on("beforeChange", function (event, slick, currentSlide, nextSlide) {
        var calc = ((nextSlide) / (slick.slideCount - 1)) * 100;
        progressBar
            .css('background-size', calc + '% 100%')
            .attr('aria-valuenow', calc);
        sliderButton
            .css('left', calc + '%');
        progressBarLabel.text(calc + '% completed');
    })

    $(".announcement-icon").click(function () {
        $(".announcement").slideUp(function () {
            $(".header").removeClass("__announcement");
        });
    })

    $(window).scroll(function() {
        const bookingButton = $('.booking-menu-wrap');
        const scroll = $(window).scrollTop();

        if (scroll > 0) {
            bookingButton.addClass('__fixed');
            $('body').addClass('__fixedbutton');
        } else {
            bookingButton.removeClass('__fixed');
            $('body').removeClass('__fixedbutton');
        }
    })
})